import { i18n } from "../../../boot/i18n";

export default {
  routes: [
    {
      name: "samples",
      path: "samples",
      meta: { icon: "sample", title: i18n.global.t("Samples") },
      component: () => import("pages/employee/Samples"),
    },
    {
      name: "samples-discarded",
      path: "samples/discarded",
      meta: {
        icon: "sample",
        title: i18n.global.t("Samples"),
        hideFromIndex: true,
      },
      component: () => import("pages/employee/Samples"),
    },
    {
      name: "samples-search",
      path: "samples/search/:query?",
      meta: {
        icon: "sample",
        title: i18n.global.t("Samples"),
        hideFromIndex: true,
      },
      component: () => import("pages/employee/Samples"),
    },
    {
      name: "samples-map",
      path: "samples-map",
      meta: {
        icon: "map",
        title: i18n.global.t("Sample Map"),
      },
      component: () => import("pages/employee/SamplesMap"),
    },
  ],

  dialogs: [
    {
      name: "sample-view",
      path: "/samples/:sampleID/view",
      meta: {
        icon: "sample",
        title: i18n.global.tc("Sample"),
      },
      component: () => import("../../../dialogs/employee/SampleView"),
    },
    {
      name: "sample-new",
      path: "/samples/new",
      meta: {
        icon: "edit",
        title: i18n.global.t("New Sample"),
      },
      component: () => import("../../../dialogs/employee/SampleEdit"),
    },
    {
      name: "sample-edit",
      path: "/samples/:sampleID/edit",
      meta: {
        icon: "edit",
        title: i18n.global.t("Edit Sample"),
      },
      component: () => import("../../../dialogs/employee/SampleEdit"),
    },
    {
      name: "sample-scan",
      path: "/samples/:sampleID/scan",
      meta: {
        icon: "qr_code",
        title: i18n.global.t("Scan Sample"),
      },
      component: () => import("../../../dialogs/employee/SampleScan"),
    },
    {
      name: "sample-qr",
      path: "/samples/:sampleID/qr",
      meta: {
        icon: "sample",
        title: i18n.global.t("Sample QR Code"),
      },
      component: () => import("../../../dialogs/employee/SampleQR"),
    },
  ],
};
